export const PRODUCT_RANGES = [
    'Opal',
    'Opal II',
    'OpalCare',
    'OPALSUPPORT',
    'Opal II Easy Height',
    'Liano',
    'Liano Care',
    'Liano II',
    'Liano Nexus',
    'Liano Junior',
    'LIANOE',
    'Urbane',
    'Urbane II',
    'Contura',
    'Contura II',
    'Luna',
    'Urbane II Universal',
  ];
